module.exports = __webpack_public_path__ + "img/OR seperator.452c7ac8.svg";